var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 610,
    height: 113,
    viewBox: "0 0 610 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 610,
    height: 113,
    rx: 17,
    fill: "#F5F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.1213 62.1213L86.0657 70.0657C87.134 71.134 87.134 72.866 86.0657 73.9343C80.29 79.71 71.1464 80.3598 64.612 75.459L59.8857 71.9143C54.6551 67.9913 50.0087 63.3449 46.0857 58.1143L42.541 53.388C37.6402 46.8536 38.29 37.71 44.0657 31.9343C45.134 30.866 46.866 30.866 47.9343 31.9343L55.8787 39.8787C57.0503 41.0503 57.0503 42.9497 55.8787 44.1213L52.8152 47.1848C52.3284 47.6716 52.2077 48.4154 52.5156 49.0312C56.0756 56.1512 61.8488 61.9244 68.9688 65.4844C69.5846 65.7923 70.3284 65.6716 70.8152 65.1848L73.8787 62.1213C75.0503 60.9497 76.9497 60.9497 78.1213 62.1213Z",
    stroke: "#7737FF",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallBox);
export default __webpack_public_path__ + "static/media/callBox.efbf149d8a19487aa0d1e322942678e3.svg";
export { ForwardRef as ReactComponent };